import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class TrackingComparatorMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   * @param {Object} param.fromPageTrackingJsonToAdvertisementsValueObjectMapper
   */
  constructor({
    config,
    fromPageTrackingJsonToTrackingDataValueObjectMapper,
    fromPageTrackingJsonToAdvertisementsValueObjectMapper
  }) {
    super()

    this._config = config
    this._culture = this._config.get('DEFAULT_CULTURE')
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
    this._fromPageTrackingJsonToAdvertisementsValueObjectMapper = fromPageTrackingJsonToAdvertisementsValueObjectMapper
  }

  _getProductsFrom({advertisements, listType}) {
    const ads = advertisements.map(ad => ({
      ...ad,
      price: 0,
      quantity: 0
    }))

    const {products} = this._fromPageTrackingJsonToAdvertisementsValueObjectMapper
      .setParams({
        adsTypeName: 'ad_impression',
        listType
      })
      .map({
        ads
      })
      .toJSON()

    return products
  }

  getTrackingData = ({advertisements = [], listType: listTypeParam, ...trackingData}) => {
    const {TRACKING_TRANSLATIONS_BY_CULTURE} = this._config.get('tracking')
    const TRACKING_LITERALS = TRACKING_TRANSLATIONS_BY_CULTURE[this._culture]
    const listType = listTypeParam ?? TRACKING_LITERALS.ADS_LIST_TYPE
    const products = this._getProductsFrom({advertisements, listType})

    return {
      ...trackingData,
      ...(products.length && {products})
    }
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {Object} param.data.advertisements
   */
  map({page, culture, data}) {
    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({page, culture})
      .map(this.getTrackingData(data))
  }
}
